// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"6695910c","787":"162c0196"}[chunkId] + ".chunk.js";
};